export default "__VITE_ASSET__Ki_qttHJ__"